import findAllPathFromTarget from "./findAllPathFromTarget";
import dayjs from 'dayjs';


const convertDiagramToRules = async (policy) => {
    let rules = [];
    let nodesCurrent = policy?.diagram?.nodes;
    let edgesCurrent = policy?.diagram?.edges;

    const getNode = (nodeId) => {
        return nodesCurrent.find(node => node?.id === nodeId) || null;
    };

    const handleValidatedRestfulApiPaths = (paths) => { // ฟังก์ชันนี้จะกรองเฉพาะ path ที่ไม่มี error_text และมี childpath

        const handleCheckedErrorPath = (path) => {
            for (const nodeId of path) {
                const node = getNode(nodeId);
                if (node?.data?.error_text && node?.data?.error_text.length > 0) {
                    return true;
                }
            }
            return false;
        };

        const handleCheckedChildPath = (path) => {
            for (const nodeId of path) {
                const node = getNode(nodeId);
                if (node?.type === 'child' || node?.type === 'childpath') {
                    return true;
                }
            }
            return false;
        };

        if (paths.length === 1) { // กรณีมีแค่ restfulapi node อันเดียว
            const validated_paths = paths.filter((path) => {
                const hasError = handleCheckedErrorPath(path?.path);
                const hasChild = handleCheckedChildPath(path?.path);
                if (!hasError && hasChild) {
                    return path;
                }
            });
            return validated_paths;
        } else {
            const validated_paths = paths.filter((path) => {
                const hasError = handleCheckedErrorPath(path?.path);
                const hasChild = handleCheckedChildPath(path?.path);
                if (!hasError && !hasChild) {
                    return path;
                }
            });
            return validated_paths;
        }
    };

    const handleGetApiResources = (node) => {
        if (node?.data?.connect_with_path) {
            const pathNode = getNode(node?.data?.connect_with_path);
            let related_nodes = [];
            let api_node = {};
            let router_node = {};
            let path_node = {};
            if (pathNode?.data?.restfulapi_parent_node) {
                api_node = getNode(pathNode?.data?.restfulapi_parent_node);
                related_nodes.push(api_node);
            }
            if (pathNode?.data?.router_parent_node) {
                router_node = getNode(pathNode?.data?.router_parent_node);
                related_nodes.push(router_node);
            }
            path_node = getNode(node?.data?.connect_with_path);
            related_nodes.push(path_node);
            const api_resource = {
                type: "API",
                name: api_node?.data?.general_properties?.name?.client_name,
                param: handleSendEndpointApiRule(related_nodes)
            }
            return [api_resource];
        } else {
            return [];
        }
    };

    // convert diagram to web rule
    const web_nodes = nodesCurrent.filter(node => node?.type === 'application' && node?.data?.general_properties?.name?.client_name);
    for (const node of web_nodes) {
        const newRule = {
            rule_id: node?.id,
            effect: "Permit",
            resource: {
                type: "WEB",
                name: node?.data?.general_properties?.name?.client_name
            },
            subject_constraint: handleConvertSubjectConstraintToString(node?.data?.general_properties?.subjectConstraints), // ""
            condition: null,
            action: [node?.data?.general_properties?.action],
            environment: {
                time: handleConvertDateTime(node?.data?.environment_properties?.date_time_verification),
                ip_address: handleConvertIPAddress(node?.data?.environment_properties?.ip_address_verification?.ipv4)
            },
            obligation: null
        };
        rules.push(newRule);
    }

    // convert diagram to api rule
    let restfulapi_nodes = nodesCurrent.filter(node => node?.type === 'restfulapi'
        && node?.data?.general_properties?.name?.client_name
        && node?.data?.general_properties?.action.length > 0
    );

    const api_rules = {};

    for (const node of restfulapi_nodes) {
        const paths = findAllPathFromTarget(nodesCurrent, edgesCurrent, node.id);
        const validated_paths = handleValidatedRestfulApiPaths(paths);
        api_rules[node.id] = validated_paths;
    }

    const arr_rules = [];
    Object.keys(api_rules).forEach(key => { // รวม api endpoint ที่ถูก validated และจะนำไปทำ api rule
        for (const path of api_rules[key]) {
            const route_path = path.path;
            let related_nodes = [];
            for (const nodeId of route_path) {
                const node = getNode(nodeId);
                related_nodes.push(node);
            }
            const api_rule = {
                route_path: route_path,
                related_nodes: related_nodes
            }
            arr_rules.push(api_rule)
        }
    });

    for (const rule of arr_rules) {
        const pathNode = rule?.related_nodes.find(node => node?.type === 'path');
        const rule_node = pathNode
            ? pathNode
            : rule?.related_nodes.find(node => node?.type === 'restfulapi')
            || false;
        const api_node = rule?.related_nodes.find((node) => {
            if (node === 'restfulapi') {
                return node;
            } else {
                return {};
            }
        });
        const newRule = {
            rule_id: rule_node?.id,
            effect: "Permit",
            resource: {
                type: "API",
                name: api_node?.data?.general_properties?.name?.client_name,
                param: handleSendEndpointApiRule(rule?.related_nodes)
            },
            subject_constraint: handleConvertSubjectConstraintToString(rule_node?.data?.general_properties?.subjectConstraints),
            condition: null,
            action: rule_node?.type === 'restfulapi' ? rule_node?.data?.general_properties?.action : [rule_node?.data?.general_properties?.action], // ถ้ามี path ย่อยออกมา filter เฉพาะที่เกิด endpoint ขึ้น
            environment: {
                resources: handleGetWebResources(rule_node?.data?.environment_properties?.resources || []),
                time: handleConvertDateTime(rule_node?.data?.environment_properties?.date_time_verification),
                ip_address: handleConvertIPAddress(rule_node?.data?.environment_properties?.ip_address_verification?.ipv4)
            },
            obligation: null
        };
        rules.push(newRule);
    }

    // convert diagram to data rule
    const data_nodes = nodesCurrent.filter(node => node?.type === 'data'
        && node?.data?.error_text.length === 0
    );
    for (const node of data_nodes) {
        const parameter_drg = await getParameterfromDRG(node?.data?.general_properties?.drg?.id);
        const newRule = {
            rule_id: node.id,
            effect: "Permit",
            resource: {
                type: "DATA",
                name: node?.data?.general_properties?.drg?.name,
                param: parameter_drg
            },
            subject_constraint: handleConvertSubjectConstraintToString(node?.data?.general_properties?.subjectConstraints),
            condition: null,
            action: [node?.data?.general_properties?.action],
            environment: {
                resources: handleGetApiResources(node),
                time: handleConvertDateTime(node?.data?.environment_properties?.date_time_verification),
                ip_address: handleConvertIPAddress(node?.data?.environment_properties?.ip_address_verification?.ipv4)
            },
            obligation: {
                drg_id: node?.data?.general_properties?.drg?.id
            }
        };
        rules.push(newRule);
    }

    return rules;
};

const convertOperandValueType = (operator) => {
    if (operator === '=') {
        return '===';
    } else if (operator === '!=') {
        return '!==';
    } else {
        return operator;
    }
};

const handleConvertSubjectConstraintToString = (subjectConstraints) => {
    const str_subject_constraint = [];
    for (const sub of subjectConstraints) {
        const childs = sub.child;
        for (const child of childs) {
            if (child?.l_operand?.name) {
                const l_operand = `request.subject.${child?.l_operand?.name}`
                str_subject_constraint.push(l_operand)
            }
            if (child?.operator) {
                const converted_operator = convertOperandValueType(child?.operator);
                const operator = ` ${converted_operator} `;
                str_subject_constraint.push(operator)
            }
            if (child?.r_operand) {
                let r_operand = '';
                if (child?.l_operand?.type === 'string') {
                    r_operand = `'${child?.r_operand}'`
                } else {
                    r_operand = `${child?.r_operand}`;
                }
                str_subject_constraint.push(r_operand)
            }
            if (child?.conjunction) {
                const converted_conjunction = child?.conjunction === 'AND' ? '&&' : '||';
                const conjunction = ` ${converted_conjunction} `
                str_subject_constraint.push(conjunction)
            }
        }
        if (sub?.conjunction) {
            const converted_conjunction = sub?.conjunction === 'AND' ? '&&' : '||';
            const conjunction = ` ${converted_conjunction} `
            str_subject_constraint.push(conjunction)
        }
    }
    return str_subject_constraint.length > 0 ? str_subject_constraint.join("") : null;
};

const handleConvertDateTime = (dateTimeVerification) => {
    const result = {};
    if (!dateTimeVerification.active || !dateTimeVerification.date_time) {
        return {};
    }
    dateTimeVerification?.date_time.forEach(item => {
        item?.days.forEach(day => {
            if (!result[day]) {
                result[day] = [];
            }
            result[day].push({
                start: item?.start,
                end: item?.end
            });
        });
    });
    return result;
};

const handleConvertIPAddress = (ipAddressVerification) => {
    if (!ipAddressVerification.active || !ipAddressVerification) {
        return "";
    }
    const ip_address_verification = ipAddressVerification ?? {};
    let ip_range = [];
    if (ip_address_verification?.range.length > 0) {
        ip_range = ip_address_verification?.range.map(ip => {
            return ip.start + "-" + ip.end;
        });
    }
    const combined_ip = [
        ...(ip_address_verification?.wild_card ?? []),
        ...(ip_address_verification?.subnet_cidr ?? []),
        ...(ip_range ?? [])
    ];

    return combined_ip.join();
};

const handleSendEndpointApiRule = (related_nodes) => {
    let endpoint;
    let prefix = "";
    let router = "";
    let path = "";
    const restfulapi_node = related_nodes.find(node => node?.type === 'restfulapi');
    const router_node = related_nodes.find(node => node?.type === 'router');
    const path_node = related_nodes.find(node => node?.type === 'path');
    if (restfulapi_node && restfulapi_node?.data?.general_properties?.prefix_path) {
        prefix = "/" + restfulapi_node?.data?.general_properties?.prefix_path;
    }
    if (router_node && router_node?.data?.general_properties?.label) {
        router = "/" + router_node?.data?.general_properties?.label;
    }
    if (path_node && path_node?.data?.general_properties?.label) {
        path = "/" + path_node?.data?.general_properties?.label;
    }
    if (!restfulapi_node?.data?.general_properties?.prefix_path
        && !router_node?.data?.general_properties?.label
        && !path_node?.data?.general_properties?.label
    ) {
        return {};
    }
    endpoint = prefix + router + path;
    return {
        path: endpoint
    };
};

const handleGetWebResources = (resources) => {
    const newResources = resources.map(r => {
        return {
            // type: r?.name?.type,
            type: r?.name?.app_type,
            name: r?.name?.client_name
        }
    });
    return newResources;
};

const getParameterfromDRG = async (drg_id) => {
    let hasParameters = [];
    const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatory/${drg_id}`);
    if (response.ok) {
        const result = await response.json();
        // const changedKeyNameInAuthorizedData = { // แก้ชื่อ key ใน authorized_data จาก attribute_selection เป็น resource_schema เพื่อให้ตรงกับที่ใช้ใน node root
        //     ...result,
        //     diagram: {
        //         ...result.diagram,
        //         nodes: result.diagram.nodes.map(node => {
        //             if (node.data.general_properties.attribute_selection) {
        //                 return {
        //                     ...node,
        //                     data: {
        //                         ...node.data,
        //                         general_properties: {
        //                             ...node.data.general_properties,
        //                             resource_schema: node.data.general_properties.attribute_selection,
        //                             attribute_selection: undefined // ลบ key attribute_selection ออก
        //                         }
        //                     }
        //                 }
        //             } else {
        //                 return node;
        //             }
        //         })
        //     }
        // };
        const drg_nodes = result?.diagram?.nodes;
        for (const node of drg_nodes) {
            if (node?.type === 'condition'
                && node?.data?.general_properties?.conditions.length > 0
                && node?.data?.warning_text.length === 0
                && node?.data?.error_text.length === 0
            ) {
                const conditions = node?.data?.general_properties?.conditions;
                for (const cond of conditions) {
                    const subConds = cond?.subConditions;
                    for (const subCond of subConds) {
                        if (subCond?.value_property?.value_type === 'Parameter') {
                            hasParameters.push(subCond?.value_property?.value)
                        }
                    }
                }
            } else {
                continue;
            }
        }
        return hasParameters;
    } else {
        return [];
    }
};

const diagramToPolicyStructue = async (policy, deployer) => {
    const rules = await convertDiagramToRules(policy);
    const policy_structure = {
        policy_diagram_id: policy?.policy_diagram_id,
        policy_diagram_name: policy?.policy_diagram_name,
        policy_diagram_description: policy?.description,
        created_by: policy?.created_by,
        created_at: policy?.created_at,
        updated_by: policy?.updated_by,
        last_updated: dayjs(policy?.last_updated).valueOf(),
        deployed_by: deployer?.displayName, // get from profile
        deployed_at: Date.now(),
        last_deployed: Date.now(),
        rules: rules
    }

    return policy_structure;
};

export async function convertOnePolicyStructure(policySelected, deployer) {
    return await diagramToPolicyStructue(policySelected, deployer);
};

export async function convertPoliciesStructure(project, policiesSelected, deployer) {
    let policies = []
    for (const policy of policiesSelected) {
        policies.push(await diagramToPolicyStructue(policy, deployer))
    }

    return {
        project_id: project?.project_id,
        project_name: project?.project_name,
        policies: policies
    };
};

export const getRuleByPolicyDiagram = async (policyDiagram) => {
    return await convertDiagramToRules(policyDiagram);
}
